// extracted by mini-css-extract-plugin
export default {"checked":"NR78NX","unchecked":"P6OenF","text":"VrIht0"};